import { CellCoordinates } from '../types/Spreadsheet';

const SEP = '|';

// Percent-encode `%` first, then the separator. Order matters: encoding `%` last
// would double-encode the `%` we just introduced when escaping `|` (which becomes
// `%7C`). Decoding reverses in the opposite order: `%7C` -> `|`, then `%25` -> `%`.
const encode = ( s: string ): string => s.replace( /%/g, '%25' ).replace( /\|/g, '%7C' );

const decode = ( s: string ): string => s.replace( /%7C/g, '|' ).replace( /%25/g, '%' );

export const getCellKey = ( cell: CellCoordinates ): string =>
  `${encode( cell.rowId )}${SEP}${encode( cell.columnId )}`;

export const parseCellKey = ( key: string ): CellCoordinates => {
  const idx = key.indexOf( SEP );
  if ( idx === -1 ) {
    // Defensive: shouldn't happen with keys produced by getCellKey, but don't
    // crash callers — return a marker that indicates parse failure.
    return { rowId: decode( key ), columnId: '' };
  }
  return {
    rowId: decode( key.slice( 0, idx )),
    columnId: decode( key.slice( idx + 1 ))
  };
};
